import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Asset } from '../../interfaces/asset.model';
import { AssetProvider } from '../../providers/asset/asset';
import { StorageProvider } from '../../providers/storage/storage';

@IonicPage()
@Component({
  selector: 'page-recents',
  templateUrl: 'recents.html',
})
export class RecentsPage {

  assets: Asset[];
  displayAsList: boolean;


  constructor(public navCtrl: NavController, public navParams: NavParams, public translate: TranslateService, public assetService: AssetProvider, public storageService: StorageProvider) {
  }

  ionViewDidLoad() {
    this.assets = this.assetService.filterAssetsLastDateOpen();
    this.getDisplayListView();
  }

   /* LIST VIEW */

   getDisplayListView(){
    this.storageService.getDataStorage("displayAsList").then(displayListView => {
      if(displayListView !== null){
        this.displayAsList = displayListView;
      } else {
        this.displayAsList = false;
      }
    });
  }

  updateListView(){
    this.displayAsList = !this.displayAsList;
    this.storageService.setDataStorage("displayAsList", this.displayAsList);
  }

}



// WEBPACK FOOTER //
// ./src/pages/recents/recents.ts